import React, { useEffect, useState, useMemo } from 'react'
import CurrentReportsPolymer from './CCPolymerSteps/components/CurrentReports'
import CurrentReportsMetal from './CCCarbonMetal/components/CurrentReports'
import { CONDITIONALROUTES, TECHTYPE } from 'app/components/ConditionalEnums';
import { ToastContainer } from "react-toastify";
import { HighestIndexArray, HotspotArray, JobsPerWeek, MachineImage, ProductionScheduleImage, SingleJobTime, TotalJobs, VisualDonut, VisualPageReload } from 'atoms/General';
import { useRecoilState, useRecoilValue } from 'recoil';
import { CostData } from 'atoms/CostToCarbonData';
import Nav from "app/components/Nav";
import { Button } from 'react-bootstrap';
import { useApolloClient } from 'react-apollo';
import { GET_CLIENT_EMAILS } from './CCSteps/components/Process/components/getStepDetail';
import { GET_PRODUCTION_SCENARIO, GET_PRODUCTION_SCENARIO_METAL } from './CCPolymerSteps/components/CarbonPolymerProcess/components/getStepDetail';
import ConsultingTeam from 'app/components/ConsultingTeam';
import ThirdReport from './CCCarbonMetal/components/CurrentReports/ThirdReport';

import { CCMetalCostOfCo2PerPartFDataM } from 'atoms/CCCarbonMetal/CCMetalPricing';
import { CCPolyCostOfCo2PerPartFData } from 'atoms/CCPolymer/CCPolyCo2Process';
import ThirdReportPolymer  from './CCPolymerSteps/components/CurrentReports/ThirdReport';
import { 
  CCPolyCo2ePerJobPMData, 
  CCPolyCo2ePerPartPMData,
  CCPolyPowderPerBuildJobData 
} from 'atoms/CCPolymer/CCPolyPowderMFG';
import socketIOClient from "socket.io-client";
import constants from 'utils/constants';
import { useRoundOffValue } from 'app/components/hooks/useRoundOffValue';
import { useGetMachineDetails } from './hooks/useGetMachineName';

const GeneratedReport = () => {
  const client = useApolloClient();
  let step_type_id = +sessionStorage.getItem("stepTypeId");


  const [reload, setReload] = useRecoilState(VisualPageReload);
  const staticCostData = useRecoilValue(CostData);
  const savedRoute = sessionStorage?.getItem("Analytics_Route");
  const [email, setEmail] = useState();
  const [clientSteps, setClientSteps] = useState([]);
  // for third report
  const [cppData, setCppData] = useState([]);
  const [totalJobs, setTotalJobs] = useRecoilState(TotalJobs);
  const [singleJobTime, setSingleJobTime] = useRecoilState(SingleJobTime);
  const [machineImage, setMachineimage] = useRecoilState(MachineImage);
  const [psImage, setPsImage] = useRecoilState(ProductionScheduleImage);
  const [cppSum, setcppSum] = useState(0);
  const [hotspotArray, setHotSpotArray] = useRecoilState(HotspotArray);
  const highestIndexArray = useRecoilValue(HighestIndexArray);
  // State for totalNumberOfJobs with working hours true and false
  const [totalJobsWithWorkingHours, setTotalJobsWithWorkingHours] = useState(null);
  const [totalJobsWithoutWorkingHours, setTotalJobsWithoutWorkingHours] = useState(null);

  


  
  
  let hightlightKey = "";
  highestIndexArray.forEach(
    (item) =>
      (hightlightKey = Object.keys(item).reduce((prevValue, currValue) =>
        item[prevValue] > item[currValue] ? prevValue : currValue
      ))
  );

  const costOfCo2pp = useRecoilValue(CCMetalCostOfCo2PerPartFDataM);

  const visualDonut = useRecoilValue(VisualDonut);
  const jobsPerWeek = useRecoilValue(JobsPerWeek);

  const groupid = parseInt(sessionStorage.getItem("group_id"));


  const handlePreviousClick = () => {
    if (savedRoute) {
      window.location.href = CONDITIONALROUTES.VISUAL_ANALYTICS_SAVED;
    } else {
      window.location.href = CONDITIONALROUTES.VISUAL_ANALYTICS;
    }
  };

  useEffect(() => {
    setReload(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    client
      .query({
        query: GET_CLIENT_EMAILS,
        variables: { group_id: groupid },
      })
      .then(({ data, loading }) => {
        setClientSteps(data.getRegionsByUserGroup);
      })
      .catch((error) => {
        console.log("error in process", error);
        // toast.error(error.graphQLErrors[0].messasge.message)
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const technology = sessionStorage.getItem("technology");

  // API calls to get totalNumberOfJobs with working hours true and false
  useEffect(() => {
    if (!staticCostData || Object.keys(staticCostData).length === 0) {
      return;
    }

    const isPolymer = technology === TECHTYPE.POLYMER;
    const query = isPolymer ? GET_PRODUCTION_SCENARIO : GET_PRODUCTION_SCENARIO_METAL;

    // Prepare variables for API call
    const baseVariables = {
      type: isPolymer ? "Polymer" : "Metal",
      setupTime: parseFloat(staticCostData?.setup_time?.value || 0),
      buildTime: parseFloat(staticCostData?.build_time?.value || 0),
      unpackingtime: parseFloat(staticCostData?.unpacking_time_per_job?.value || 0),
      isOnlyWorkingHours: false,
    };

    // Add coolDownTime for Polymer
    if (isPolymer) {
      baseVariables.coolDownTime = parseFloat(staticCostData?.cool_down_time_in_system?.value || 0);
    }

    // Call API with working hours = false
    client
      .query({
        query: query,
        variables: { ...baseVariables, isOnlyWorkingHours: false },
        fetchPolicy: 'no-cache'
      })
      .then((data) => {
        const totalJobs = data?.data?.productionScheduling?.totalNumberOfJobs;
        setTotalJobsWithoutWorkingHours(totalJobs);
      })
      .catch((error) => {
        console.log("error in production scenario API (working hours false)", error);
      });

    // Call API with working hours = true
    client
      .query({
        query: query,
        variables: { ...baseVariables, isOnlyWorkingHours: true },
        fetchPolicy: 'no-cache'
      })
      .then((data) => {
        const totalJobs = data?.data?.productionScheduling?.totalNumberOfJobs;
        setTotalJobsWithWorkingHours(totalJobs);
      })
      .catch((error) => {
        console.log("error in production scenario API (working hours true)", error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [staticCostData, technology]);




  // for third report
  // Getting Currency Symbol...
  const currencies = JSON.parse(sessionStorage.getItem("all_currencies"));
  const currency = sessionStorage.getItem("currency");
  const obj = currencies.find((x) => x.currency_symbol === currency);

  const co2TotalToday = sessionStorage.getItem("co2TotalToday");

  // Read scenarios data from sessionStorage
  const [scenariosData, setScenariosData] = useState(null);
  const [scenarios, setScenarios] = useState([]);
  // Jobs/week per scenario and shift — used by PDF utilization table
  const [scenarioTotalJobs, setScenarioTotalJobs] = useState({});
  const [scenarioJobsLoading, setScenarioJobsLoading] = useState(false);

  useEffect(() => {
    // Always include staticCostData as the default scenario
    // This ensures consistent handling of single vs multiple scenarios in PDFs
    const allScenariosData = {
      [constants.DEFAULT_SCENARIO]: staticCostData
    };
    
    // Check if additional scenarios exist
    const calculatorValuesNames = sessionStorage.getItem("calculator_values_names");
    
    if (calculatorValuesNames) {
      try {
        const scenarioNames = JSON.parse(calculatorValuesNames);
        
        // Load additional scenario data (excluding default as we already have it)
        scenarioNames.forEach((scenarioName) => {
          // Skip default scenario as we already have staticCostData
          if (scenarioName !== constants.DEFAULT_SCENARIO) {
            const scenarioData = sessionStorage.getItem(`calculator_values_${scenarioName}`);
            if (scenarioData) {
              try {
                allScenariosData[scenarioName] = JSON.parse(scenarioData);
              } catch (e) {
                console.error(`Error parsing scenario data for ${scenarioName}:`, e);
              }
            }
          }
        });
        
        // Ensure DEFAULT_SCENARIO is always included in the scenarios list
        // Get all scenario names and ensure Default is included
        const allScenarioNames = Object.keys(allScenariosData);
        
        // Create scenarios array: always include DEFAULT_SCENARIO first, then others
        const scenarioSet = new Set(allScenarioNames);
        // Ensure DEFAULT_SCENARIO is in the set (it should be, but be explicit)
        if (!scenarioSet.has(constants.DEFAULT_SCENARIO) && staticCostData) {
          scenarioSet.add(constants.DEFAULT_SCENARIO);
        }
        
        const sortedScenarios = Array.from(scenarioSet).sort((a, b) => {
          if (a === constants.DEFAULT_SCENARIO) return -1;
          if (b === constants.DEFAULT_SCENARIO) return 1;
          return 0;
        });
        
        setScenarios(sortedScenarios);
        
        // Set scenariosData if we have more than just the default scenario
        // This allows PDF to distinguish between single and multiple scenarios
        // Always ensure DEFAULT_SCENARIO is included in scenariosData
        if (allScenarioNames.length > 1) {
          // Ensure DEFAULT_SCENARIO is explicitly included
          const finalScenariosData = {
            ...allScenariosData,
            [constants.DEFAULT_SCENARIO]: staticCostData // Explicitly set to ensure it's there
          };
          setScenariosData(finalScenariosData);
        } else {
          // Single scenario: set to null so PDF treats it as single scenario
          setScenariosData(null);
        }
      } catch (e) {
        console.error("Error parsing scenario names:", e);
        setScenariosData(null);
        setScenarios([constants.DEFAULT_SCENARIO]);
      }
    } else {
      // No additional scenarios, only default
      setScenariosData(null);
      setScenarios([constants.DEFAULT_SCENARIO]);
    }
  }, [staticCostData]);

  // Calculate total jobs for each scenario to show dynamic utilization
  useEffect(() => {
    if (!scenariosData || Object.keys(scenariosData).length <= 1) {
      setScenarioJobsLoading(false);
      return; // Only for multiple scenarios
    }

    setScenarioJobsLoading(true);

    const isPolymer = technology === TECHTYPE.POLYMER;
    const query = isPolymer ? GET_PRODUCTION_SCENARIO : GET_PRODUCTION_SCENARIO_METAL;

    const newScenarioTotalJobs = {};
    let completedRequests = 0;
    const totalRequests = Object.keys(scenariosData).length * 2; // 2 API calls per scenario

    // Calculate totalJobs for each scenario
    Object.entries(scenariosData).forEach(([scenarioName, scenarioData]) => {
      if (!scenarioData || Object.keys(scenarioData).length === 0) {
        return;
      }

      const baseVariables = {
        type: isPolymer ? "Polymer" : "Metal",
        setupTime: parseFloat(scenarioData?.setup_time?.value || 0),
        buildTime: parseFloat(scenarioData?.build_time?.value || 0),
        unpackingtime: parseFloat(scenarioData?.unpacking_time_per_job?.value || 0),
        isOnlyWorkingHours: false,
      };

      if (isPolymer) {
        baseVariables.coolDownTime = parseFloat(scenarioData?.cool_down_time_in_system?.value || 0);
      }

      // Call API with working hours = false (24/7)
      client
        .query({
          query: query,
          variables: { ...baseVariables, isOnlyWorkingHours: false },
          fetchPolicy: 'no-cache'
        })
        .then((data) => {
          const totalJobs = data?.data?.productionScheduling?.totalNumberOfJobs;
          newScenarioTotalJobs[`${scenarioName}_without_wh`] = totalJobs;
          completedRequests++;
          if (completedRequests === totalRequests) {
            setScenarioTotalJobs(newScenarioTotalJobs);
          }
        })
        .catch((error) => {
          console.log(`error in production scenario API for ${scenarioName} (working hours false)`, error);
          completedRequests++;
          if (completedRequests === totalRequests) {
            setScenarioTotalJobs(newScenarioTotalJobs);
          }
        });

      // Call API with working hours = true (8 h / 5 d)
      client
        .query({
          query: query,
          variables: { ...baseVariables, isOnlyWorkingHours: true },
          fetchPolicy: 'no-cache'
        })
        .then((data) => {
          const totalJobs = data?.data?.productionScheduling?.totalNumberOfJobs;
          newScenarioTotalJobs[`${scenarioName}_with_wh`] = totalJobs;
          completedRequests++;
          if (completedRequests === totalRequests) {
            setScenarioTotalJobs(newScenarioTotalJobs);
            setScenarioJobsLoading(false);
          }
        })
        .catch((error) => {
          console.log(`error in production scenario API for ${scenarioName} (working hours true)`, error);
          completedRequests++;
          if (completedRequests === totalRequests) {
            setScenarioTotalJobs(newScenarioTotalJobs);
          }
        });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scenariosData, technology]);


  const allMachineIds = useMemo(() => {
    const machineIds = new Set();
    
    // Add machine ID from staticCostData (default scenario)
    if (staticCostData?.machine_id?.value) {
      const machineId = +staticCostData.machine_id.value;
      if (machineId && !isNaN(machineId) && machineId > 0) {
        machineIds.add(machineId);
      }
    }
    
    // Add machine IDs from all additional scenarios
    if (scenariosData) {
      Object.values(scenariosData).forEach((scenarioData) => {
        // Check both nested costData structure and direct machine_id
        const machineIdValue =  scenarioData?.machine_id?.value;
        if (machineIdValue) {
          const machineId = +machineIdValue;
          if (machineId && !isNaN(machineId) && machineId > 0) {
            machineIds.add(machineId);
          }
        }
      });
    }
    
    return Array.from(machineIds);
  }, [staticCostData, scenariosData]);

  // Batch fetch all machine details for efficiency
  const { machineDetails: allMachineDetails, machineDetailsArray } = useGetMachineDetails(allMachineIds);
  
  // Get machine details for current/default scenario
  const currentMachineId = staticCostData?.machine_id?.value ? +staticCostData.machine_id.value : null;
  const machineDetails = currentMachineId ? allMachineDetails[currentMachineId] : null;
  const machineName = machineDetails?.name;
  const machineImageUrl = machineDetails?.image_url || "";
  console.log("machineDetails", machineDetails)
  console.log("machineDetailsArray", machineDetailsArray)
  console.log("allMachineIds", allMachineIds)
  console.log(scenariosData,"scenariosData")
  return (
    <>
      <ToastContainer />
      <Nav />
      <div className="row  container-form ">
        <div className="col page-container px-0  max-screen-width">
          <div className="">
            <div className="d-flex justify-content-between   mb-24">
              <span className="font-32 font-semi-bold">Cost Reports</span>
              <div className="d-flex gap-8">
                <Button
                  className="button1 button btn-black  m-0"
                  style={{ width: "fit-content" }}
                  onClick={() => handlePreviousClick()}
                >
                  <div className="d-flex gap-8">
                    <img
                      alt=""
                      src="../assets/analytics.png"
                      width="22"
                      height="22"
                    />
                    <p>Visual Analytics</p>
                  </div>
                </Button>
                <ConsultingTeam navigate={email} isMarginNone />
              </div>
            </div>
            <div className="report-divider"></div>
            <div className="d-flex gap-12 mb-36 mt-24">
              <img
                src="../assets/arrow-left.svg"
                alt="bread-crumb arrow"
                // height="32"
                // width="32"
              />
              <span className="font-14 color-grey">
                {step_type_id === 1
                  ? "Simple Part Cost Estimation"
                  : "Detailed Part Cost Estimation"}
              </span>
            </div>
            {technology === TECHTYPE.POLYMER ? (
              <CurrentReportsPolymer
                
                isHotSpotAvailable={true}
                cppData={cppData}
                setCppData={setCppData}
                totalJobs={totalJobs}
                setTotalJobs={setTotalJobs}
                setSingleJobTime={setSingleJobTime}
                singleJobTime={singleJobTime}
                machineImage={machineImage}
                setMachineimage={setMachineimage}
                psImage={psImage}
                setPsImage={setPsImage}
                setcppSum={setcppSum}
                cppSum={cppSum}
                setHotSpotArray={setHotSpotArray}
                hotspotArray={hotspotArray}
                scenarioTotalJobs={scenarioTotalJobs}
                scenarioJobsLoading={scenarioJobsLoading}
              />
            ) : (
              <CurrentReportsMetal
                isHotSpotAvailable={true}
                staticDataOfMachine={staticCostData}
                setCppData={setCppData}
                setTotalJobs={setTotalJobs}
                cppData={cppData}
                totalJobs={totalJobs}
                setSingleJobTime={setSingleJobTime}
                singleJobTime={singleJobTime}
                machineImage={machineImage}
                setMachineimage={setMachineimage}
                psImage={psImage}
                setPsImage={setPsImage}
                setcppSum={setcppSum}
                cppSum={cppSum}
                setHotSpotArray={setHotSpotArray}
                hotspotArray={hotspotArray}
                scenarioTotalJobs={scenarioTotalJobs}
                scenarioJobsLoading={scenarioJobsLoading}
               
              />
            )}
          </div>
        </div>
      </div>
      <div className="border-top mt-24">
        <div className="d-flex mx-80 my-12   justify-content-end">
          <>
            {technology === TECHTYPE.POLYMER ? (
              <>
                <ThirdReportPolymer
                  totalJobsWithWorkingHours={totalJobsWithWorkingHours}
                  totalJobsWithoutWorkingHours={totalJobsWithoutWorkingHours}
                  cppData={cppData}
                  staticData={staticCostData}
                  currency={obj.currency_symbol}
                  costOfCo2pp={costOfCo2pp}
                  visualDonut={visualDonut}
                  jobsPerWeek={jobsPerWeek}
                  totalJobs={totalJobs}
                  singleJobTime={singleJobTime}
                  machineImage={machineImage}
                  psImage={psImage}
                  cppSum={cppSum}
                  hotspotArray={hotspotArray}
                  hightlightKey={hightlightKey}
                  isHotSpotAvailable={true}
              
                  // CO2e={localStorage.getItem("co2TotalToday") || "34"}

                  CO2e={co2TotalToday}
                  machineDetails={machineDetails}
                  machineImageUrl={machineImageUrl}
                  machineName={machineName}
                  scenariosData={scenariosData}
                  scenarios={scenarios}
                  allMachineDetails={allMachineDetails}
                  machineDetailsArray={machineDetailsArray}
                  scenarioTotalJobs={scenarioTotalJobs}
                />
              </>
            ) : (
              <ThirdReport
                totalJobsWithWorkingHours={totalJobsWithWorkingHours}
                totalJobsWithoutWorkingHours={totalJobsWithoutWorkingHours}
                cppData={cppData}
                staticDataOfMachine={staticCostData}
                currency={obj.currency_symbol}
                costOfCo2pp={costOfCo2pp}
                visualDonut={visualDonut}
                jobsPerWeek={jobsPerWeek}
                totalJobs={totalJobs}
                singleJobTime={singleJobTime}
                machineImage={machineImage}
                psImage={psImage}
                cppSum={cppSum}
                hotspotArray={hotspotArray}
                hightlightKey={hightlightKey}
                isHotSpotAvailable={true}
                CO2e={co2TotalToday}
                machineDetails={machineDetails}
                machineImageUrl={machineImageUrl}
                machineName={machineName}
                scenariosData={scenariosData}
                scenarios={scenarios}
                allMachineDetails={allMachineDetails}
                machineDetailsArray={machineDetailsArray}
                scenarioTotalJobs={scenarioTotalJobs}
              />
            )}
          </>
        </div>
      </div>
    </>
  );
}

export default GeneratedReport